module.exports = __webpack_public_path__ + "img/bus_marker_red.7a4bd012.png";